export default "__VITE_ASSET__C11J3mes__"